/**
 * User reducers
 * the files contains all reducers related to countries
 *
 * !!! Reducer is required to be pure function
 */

const setLoyaltyInformationReducer = (state, action) => {
  return {...action.payload.loyaltyInformation}
}
const setStoredValueBalancesReducer = (state, action) => {
  return action.payload.storedValueBalances
}
const setMostRecentStoredValueTransactionReducer = (state, action) => {
  return { ...action.payload.mostRecentStoredValueTransaction }
}
const setUserReducer = (state, action) => {
  return {...action.payload.user}
}
const setUserReadyReducer = (state, action) => {
  return action.payload.userReady
}

const reducer = (state, action) => {
  switch (action.type) {
    case 'SET_USER':
      return {
        ...state,
        user: setUserReducer(state, action)
      }
    case 'SET_LOYALTY_INFORMATION':
      return {
        ...state,
        loyaltyInformation: setLoyaltyInformationReducer(state, action)
      }
    case 'SET_MOST_RECENT_STORED_VALUE_TRANSACTION':
      return {
        ...state,
        mostRecentStoredValueTransaction: setMostRecentStoredValueTransactionReducer(state, action)
      }
    case 'SET_STORED_VALUE_BALANCES':
      return {
        ...state,
        storedValueBalances: setStoredValueBalancesReducer(state, action)
      }
    case 'SET_USER_READY':
      return {
        ...state,
        userReady: setUserReadyReducer(state, action)
      }
  }
}

export default reducer
